import { Component, Input, OnInit } from '@angular/core';
import {
    IMovementScheduleAccount,
    IMovementScheduleFli,
    IStyleOptions,
} from '@modeso/types__aumico-lib-annualreport-be';
import { TemplateType } from '@modeso/types__aumico-lib-templates-be';
import Debug from 'debug';
import { IMovementScheduleDates } from '../../../../interfaces/movement-schedule/IMovementScheduleDates.interface';

const debug = Debug('aumico:aumico-lib-notes-fe:MovementScheduleTablePrintPreview');

@Component({
    selector: 'aumico-notes-movements-schedule-table-print-preview-deprecated',
    templateUrl: 'movement-schedule-print-preview-table-deprecated.component.html',
    styleUrls: ['movement-schedule-print-preview-table-deprecated.component.scss'],
})
export class MovementScheduleTablePrintPreviewComponent implements OnInit {
    readonly mockedIndex = '0';
    displayedColumns: string[] = ['text', 'openValue', 'column1', 'column2', 'column3', 'column4', 'closeValue'];
    accounts: (IMovementScheduleAccount & { className: string })[];
    constructor() {}

    private tableDates: IMovementScheduleDates | undefined;
    @Input() set dates(value: IMovementScheduleDates) {
        if (value == null) {
            return;
        }
        this.tableDates = { ...value };
        this.prepareDates();
    }

    openDate: string;
    closeDate: string;

    fliData: IMovementScheduleFli | undefined;
    @Input() set data(value: IMovementScheduleFli) {
        if (value == null) {
            return;
        }
        this.fliData = { ...value };
        this.prepareDates();
        this.accounts = value.accounts.map((account) => ({ ...account, className: '' }));
        if (this.accounts.length > 0) {
            this.accounts[this.accounts.length - 1].className = 'black-border';
        }
        this.accounts.push({ ...value.totalRow, className: 'footer black-border', id: 'mocked' });
    }

    currentFliIndex = this.mockedIndex;
    @Input() set fliIndex(value: string) {
        if (value != null) {
            this.currentFliIndex = value;
        }
    }

    currentAccordionIndex = this.mockedIndex;
    @Input() set accordionIndex(value: string) {
        if (value != null) {
            this.currentAccordionIndex = value;
        }
    }

    availableCurrentLanguage = 'de-ch';
    @Input() set currentLanguage(value: string) {
        if (value != null) {
            this.availableCurrentLanguage = value;
        }
    }

    @Input() numberFormat = '1.2-2';

    textColor: string;
    backgroundColor: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    @Input() set stylePreferenceOptions(value: IStyleOptions) {
        if (value != null) {
            this.textColor = value.textColor;
            this.backgroundColor = value.backgroundColor;
            this.tableHeaderColor = value.tableHeaderColor;
            this.tableFooterColor = value.tableFooterColor;
        }
    }
    showPreviousData = true;
    @Input() set noPreviousData(value: boolean) {
        if (value) {
            this.displayedColumns = ['text', 'column1', 'column2', 'column3', 'column4', 'closeValue'];
            this.showPreviousData = false;
        }
    }

    ngOnInit(): void {
        debug('ngOnInit');
    }

    private prepareDates(): void {
        if (this.fliData == null || this.tableDates == null) {
            return;
        }
        if (this.fliData.templateType === TemplateType.BALANCE) {
            this.openDate = this.tableDates.balanceOpenDate;
            this.closeDate = this.tableDates.balanceCloseDate;
        } else {
            this.openDate = this.tableDates.incomeOpenDate;
            this.closeDate = this.tableDates.incomeCloseDate;
        }
    }
}
